export function SubmitButton({ loading, loadingLabel, children, testId, className = "" }) {
  return (
    <button type="submit" disabled={loading} data-testid={testId} aria-busy={loading} className={`mw-btn mw-btn-primary w-full ${className}`}>
      {loading && <span className="mw-spinner mw-spinner-light" aria-hidden="true" />}
      <span>{loading ? loadingLabel : children}</span>
    </button>
  );
}
